import { httpClient } from '@/api/http-client'
import { Borrower } from '@/types'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export type BorrowerDataUpdate = {
  name: string
  email?: string
  phone?: string
  deal_id?: number
  customer_id?: number
  address?: {
    zip_code: string
    number: string
    complement?: string
    street: string
    district: string
    ibge_code: string | null
    state_code: string | null
  }
}

export type UpdateBorrowerParams = {
  companyKey: string
  borrowerKey: string
  borrowerData: BorrowerDataUpdate
}

export const updateBorrower = async ({
  companyKey,
  borrowerKey,
  borrowerData,
}: UpdateBorrowerParams): Promise<Borrower> => {
  const response = await httpClient('accounting-dealer').put<Borrower>(
    `/v3/company/${companyKey}/borrower/${borrowerKey}`,
    borrowerData,
  )
  return response.data
}

export const useUpdateBorrower = (
  options?: UseMutationOptions<Borrower, AxiosError, UpdateBorrowerParams>,
) => {
  return useMutation({
    mutationFn: updateBorrower,
    ...options,
  })
}
